import { CustomDetailCategory } from '@dealstack/shared/lib/generated';

export const categoryOptions = [
	{ value: CustomDetailCategory.TAX_RESIDENCY, label: 'Tax Residency' },
	{ value: CustomDetailCategory.FATCA, label: 'FATCA' },
	{ value: CustomDetailCategory.CRS, label: 'CRS' },
	{ value: CustomDetailCategory.GDPR, label: 'GDPR' },
];
